import React from 'react';

import EmbeddedIFrame from 'views/Frames/EmbeddedIFrame';
import { useRuntimeConfig } from 'config/useRuntimeConfig';
import PageTitleToken from 'components/Common/PageTitleToken';
import { TOPBAR_HEIGHT } from 'services/constants';

const GlobalPartnerHandlingDeskIFrame = ({
  path,
  heightOffset = `${TOPBAR_HEIGHT}px`,
}: {
  path: string;
  heightOffset?: string;
}) => {
  const runtimeConfig = useRuntimeConfig();
  return (
    <>
      <PageTitleToken />
      <EmbeddedIFrame
        url={`${runtimeConfig.configData.iframeUrls.globalPartnerHandlerIframe}${path}`}
        title="GPHD"
        id="global-partner-handling-desk-iframe"
        height={`calc(100% - ${heightOffset})`}
      />
    </>
  );
};

export default GlobalPartnerHandlingDeskIFrame;
